import plugFeatures from "./plugFeatures";

export default URL;
plugFeatures(URL);
